var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5V3.5H8.59162C9.26963 3.5 9.83311 3.60254 10.2821 3.80762C10.7341 4.00977 11.0716 4.28662 11.2945 4.63818C11.5205 4.98975 11.6335 5.38818 11.6335 5.8335C11.6335 6.19971 11.5602 6.51318 11.4136 6.77393C11.267 7.03174 11.07 7.24121 10.8226 7.40234C10.5753 7.56348 10.2989 7.6792 9.99346 7.74951V7.8374C10.3264 7.85498 10.6455 7.95312 10.9509 8.13184C11.2594 8.30762 11.5113 8.55664 11.7068 8.87891C11.9023 9.20117 12 9.59082 12 10.0479C12 10.5137 11.8824 10.9326 11.6473 11.3047C11.4121 11.6738 11.0578 11.9653 10.5844 12.1792C10.111 12.3931 9.51549 12.5 8.79777 12.5H5ZM6.69961 11.1377H8.52749C9.14441 11.1377 9.58879 11.0249 9.8606 10.7993C10.1355 10.5708 10.2729 10.2778 10.2729 9.92041C10.2729 9.65381 10.2042 9.41357 10.0668 9.19971C9.92932 8.98291 9.73386 8.81299 9.48037 8.68994C9.22688 8.56397 8.92452 8.50098 8.57330 8.50098H6.69961V11.1377ZM6.69961 7.32764H8.38089C8.67408 7.32764 8.93826 7.27637 9.17343 7.17383C9.4086 7.06836 9.59337 6.92041 9.72775 6.72998C9.86518 6.53662 9.9339 6.30811 9.9339 6.04443C9.9339 5.6958 9.80563 5.40869 9.54908 5.18311C9.29559 4.95752 8.91841 4.84473 8.41754 4.84473H6.69961V7.32764Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/Bold.b4a52a99dea1a6af5b11393b4f25decd.svg";
export { ForwardRef as ReactComponent };